import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=92176b36&scoped=true"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"
import style0 from "./NewClient.vue?vue&type=style&index=0&id=92176b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92176b36",
  null
  
)

export default component.exports